/* eslint-disable */

<template>
    <div class="container-fluid mt-4 mb-2 removeSpacing">
<!-- Modal -->
<div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="confirmationModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-weight-bold" id="confirmationModalLabel">Your request has been submitted</h5>
      </div>
      <div class="modal-body">
         <p class="text-center">
         <i class="fa fa-check-circle fa-5x" aria-hidden="true"></i>
         </p>
       <p><b>Date Submitted:</b> {{ this.stringDate}}</p>
       <br />
       <p><b>Name:</b> {{ this.submittedRequest.req_contact_first}} {{ this.submittedRequest.req_contact_last}}</p>
       <p><b>Address:</b> {{ this.submittedRequest.req_location}}</p>
       <p><b>Types:</b> {{ this.request_types.join(", ")}}</p>
      
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="this.resetSubmit">Okay</button>
      </div>
    </div>
  </div>
</div>
      <div class="container-fluid removeSpacing">
        <div style="position: relative;left: -30px;">
        <!-- Opens New Request Dropdown -->
        <button
          @click="requestCustomOpen"
          class="btn btn-success"
          type="button"
          data-toggle="collapse"
          data-target="#newRequestCustomCollapse"
          aria-expanded="false"
          aria-controls="newRequestCustomCollapse"
          v-if="collapseCustomState == 'hide'"
          :class="{ 'd-none': (show == 'true')}"
        >
          <i class="fas fa-plus-circle mr-2" ></i> Add Request
        </button>

        <!-- Closes New Request Dropdown -->
        <button
          @click="requestCustomClose"
          class="btn btn-secondary mb-3"
          type="button"
          data-toggle="collapse"
          data-target="#newRequestCustomCollapse"
          aria-expanded="false"
          aria-controls="newRequestCustomCollapse"
          v-if="collapseCustomState == 'show'"
          :class="{ 'd-none': (show == 'true')}"
        >
          <i class="far fa-times-circle mr-2"></i> Close
        </button>
        </div>

        <!-- Start of Collapse Request Form -->
        <div
          class="collapse container-fluid removeSpacing"
          :class="{ show: (show == 'true')}"
          id="newRequestCustomCollapse"
        >
          <div class="container-fluid bg-light rounded text-black removeSpacing">
            <!-- New Request Form -->
            <h2 class="card-title font-weight-bold pl-4">Bulk Trash Pickup: <span class="text-success">East Greenwich, NJ</span></h2>
        <p class="card-title pl-4" style="font-size: 16px">Use the interactive form below to schedule a new bulk trash pickup at your residence. The current pickup schedule and additional information about specific bulk types can be found towards the bottom of this page.</span></p>
        <!-- Start of Collapse Request Form -->
        <div class="container-fluid pb-3 removeSpacing" id="newRequestCustomCollapse">
          <div class="container-fluid bg-light rounded text-black ">
            <!-- New Request Form -->
            <h5 class="mt-1 mb-4">New Request</h5>
            <div class="row">
              <!-- Conditional Show for First Name -->
              <div class="col-md-6" v-show="x === 'one'">
                <div class="form-group">
                  <p class="ml-0 mb-1">First</p>
                  <input
                    type="text"
                    name
                    v-model="request.req_contact_first"
                    placeholder="First Name"
                    class="form-control"
                  />
                </div>
              </div>

              <!-- Conditional Show for Last Name -->
              <div class="col-md-6" v-show="x === 'one'">
                <div class="form-group">
                  <p class="ml-0 mb-1">Last</p>
                  <input
                    type="text"
                    name
                    v-model="request.req_contact_last"
                    placeholder="Last Name"
                    class="form-control"
                  />
                </div>
              </div>

              <!-- Conditional Show for House Number -->
              <!-- NOT currently showing -->
              <div class="col-md-6" v-show="y === 'two' || y === 'three'">
                <div class="form-group">
                  <p class="ml-0 mb-1">House Number</p>
                  <input
                    type="text"
                    v-model="request.req_street_number"
                    placeholder="Seperate from street name"
                    class="form-control"
                    disabled
                  />
                </div>
              </div>

              <!-- Conditional Show for Street Name -->
              <!-- NOT currently showing -->
              <div class="col-md-6" v-show="y === 'two'">
                <div class="form-group">
                  <p class="ml-0 mb-1">Street Name</p>
                  <input
                    type="text"
                    v-model="request.req_street_name"
                    placeholder="Street name"
                    class="form-control"
                    disabled
                  />
                </div>
              </div>

              <!-- Conditional Show for Phone -->
              <div class="col-md-6" v-show="z === 'one' || z === 'two'">
                <div class="form-group">
                  <p class="ml-0 mb-1">Phone</p>
                  <input
                    type="text"
                    name
                    v-model="request.req_phone"
                    placeholder="Phone"
                    class="form-control"
                  />
                </div>
              </div>

              <div class="col-md-6" v-show="z === 'one' || z === 'two'">
                <div class="form-group">
                  <p class="ml-0 mb-1">Email <span class="font-weight-bold text-danger" v-if='!this.validateEmail(request.req_email)'>*</span></p>
                  <input
                    type="text"
                    v-model="request.req_email"
                    placeholder="Email"
                    class="form-control"
                  />
                </div>
              </div>

              <!-- Autocomplete Address -->
              <div
                class="col-md-6"
                v-show="y === 'one' || y === 'two' || y === 'three'"
              >
                <div class="form-group">
                  <p class="ml-0 mb-1">Address</p>
                  <form>
                  <input
                    id="inputPlace"
                    ref="autocomplete"
                    autocomplete="password"
                    placeholder="Address"
                    class="search-location form-control"
                    onfocus="value = ''"
                    type="text"
                  />
                  </form>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <br />
                </div>
              </div>
              <div
                class="col-md-12 px-4"
                
              >
                <div role="alert" class="alert alert-danger mt-3"><h4 class="alert-heading font-weight-bold">Important!</h4>
                <p>
                Specific bulk-trash types are gathered throughout the week.
                Please ensure that you request your bulk-trash pick-up no later
                than
                <strong >10:00 a.m on Monday</strong> to be placed on the pick-up
                list for that week. Otherwise, your pick-up will be scheduled
                for the following week. Holidays may alter the special
                collection items schedule. Please call for specific cut off
                request dates.
              </p>
              <hr><h6 class="alert-heading font-weight-bold">Pickup Conditions</h6><p class="mb-0" style="word-wrap: break-word;">
              No more than the size of a living room set will be picked up at
              one bulk stop. Entire houselhold cleanouts will not be picked up
              by the Township. Carpeting and fence must be cut in lengths of
              4-feet and tied with string or twine, and not weight more than
              50 pounds. The Public Works Department will not collect
              hazardous materials and or construction/remodeling debris such
              as plywood, shingles, brick, stone, insulation, siding,
              concrete, sheet rock, flooring, and carpets if work is done by a
              contractor.
              </p></div>
                <div class="form-group">
                  <hr style="width: 80%; margin: auto auto" />
                </div>
              </div>

              <div
                class="col-md-6"
              >
                <p class="ml-0 mb-1">Bulk Type: <span class="text-info">You can choose one or <strong>multiple</strong> bulk types to submit multiple requests at once.</span></p>
              <multiselect :multiple="true" v-model="request.req_type" :options="getBulkTypeList(sortBulkTypes(bulkTypes, true))">
                  </multiselect>
              </div>
              <div
                class="col-md-6"
              >
              </div>
              <div class="col-md-12" >
                <div class="row">
                  <template v-for="(type) in sortBulkTypes(bulkTypes)" >
                  <BulkRequestDescription :key="type.id" v-model="descriptions[type.name]"  :type="type.name" v-if="checkForRequestType(type.name)" />
                  </template>

              <div v-if='showZone == "true"' class="col-md-6">
                <div class="form-group">
                  <p class="ml-0 mb-1">Zone</p>
                  <input
                    type="text"
                    name
                    v-model="request.req_zone"
                    placeholder="Zone"
                    class="form-control"
                  />
                </div>
                </div>
              </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <br />
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="container-fluid"
                  v-for="type in sortBulkTypes(bulkTypes)"
                  :key="type.id"
                >
                  <div v-if="checkForRequestType(type.name)">
                    <BulkTypeCard :pickup="type.pickup" :type="type.name" :msg="type.message" />
                  </div>

                </div>
              </div>
              <div v-if="!this.validateEmail(request.req_email)" class="col-md-12">
                <span class="font-weight-bold text-danger">Please enter an email address</span>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <input
                    v-show="request.req_type"
                    type="submit"
                    @click="addProduct"
                    value="Save and Add"
                    class="btn btn-success mt-4"
                    :disabled="this.validateEmail(request.req_email) ? false : 'disabled'"
                  />
                  <input
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Select a Bulk Type before continuing"
                    v-show="!request.req_type"
                    type="submit"
                    value="Select a Bulk Type"
                    class="btn btn-secondary text-dark mt-4"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Content -->
</template>

<script>
import { fb, db } from "../firebase";
import Multiselect from "vue-multiselect";
import BulkTypeCard from "./design/BulkTypeCard.vue";
import BulkRequestDescription from "./design/BulkRequestDescription.vue";
import { mapState, mapGetters } from 'vuex'
import { dbSchema } from "../store"
  

export default {
  name: "EmpMyRequests",
  components: { Multiselect, BulkTypeCard, BulkRequestDescription },
  props: ["title", "showZone", "show", "anonymous"],
  data() {
    return {
      todaysDate: Date.now(),
      descriptions: {
        description1: "",
        description2: "",
        description3: "",
        description4: "",
        description5: "",
      },
      request_types: [],
      request: {
        //Standard
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        //Home Phone
        req_phone: null,
        req_email: null,
        req_contact_first: null,
        req_contact_last: null,
        req_street: null,
        req_internal_addr: null,
        req_city: null,
        req_state: null,
        req_zip: null,
        req_street_name: null,
        req_street_number: null,
        req_cell_phone: null,
        req_work_phone: null,
        req_work_phone_ext: null,
        req_submitted: null,
        timestamp: null,
      },
      submittedRequest: {
        //Standard
        req_assigned: null,
        req_type: [],
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        //Home Phone
        req_phone: null,
        req_email: null,
        req_contact_first: null,
        req_contact_last: null,
        req_street: null,
        req_internal_addr: null,
        req_city: null,
        req_state: null,
        req_zip: null,
        req_street_name: null,
        req_street_number: null,
        req_cell_phone: null,
        req_work_phone: null,
        req_work_phone_ext: null,
        req_submitted: null,
        timestamp: null,
      },
      req_address_received: false,
      date: new Date().toISOString(),
      activeItem: null,
      modal: null,
      collapseState: null,
      collapseCustomState: null,
      x: "one",
      y: "one",
      z: "one",
      layout: null,
    };
  },
  created() {
    this.collapseState = "shrunk";
    this.collapseCustomState = "hide";
    this.layout = "one";
  },
  mounted() {
    // Init Autocomplete, create an autocomplete object
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ["geocode"] }
    );
    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace();
      let ac = place.address_components;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let addr = place.formatted_address;
      
      let number = ac[0]["short_name"];
      let streetname = ac[1]["short_name"];
      let thecity = ac[3]["short_name"];
      let thestate = ac[5]["short_name"];
      let thezip = ac[7]["short_name"];
      this.request.req_location = addr;
      this.request.req_street_number = number;
      this.request.req_street_name = streetname;
      this.request.req_city = thecity;
      this.request.req_state = thestate;
      this.request.req_zip = thezip;
      this.req_address_received = true;
    });
  },
  computed: {
    ...mapState([
    'bulksettings',
    'bulkTypes'
  ]),
    ...mapGetters({
      user: "user"
    }),
    stringDate() {
      const date = new Date(this.date);
      
      return date.toLocaleDateString("en-US");
    },
  },
  methods: {
    sortBulkTypes(bulkTypes, dropEmpty=false) {
      const emptyData = [];
      var types = bulkTypes.filter(item => {
        if(item.name == "" || item.name == null) {
            emptyData.push(item)
            return false;
        }
        return true
      })

      types = types.sort(function (a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();

        if(textA < textB)
            return -1

        if(textA > textB) {
          return 1;
        }

        return 0;
      });

      if(!dropEmpty)
          return types.concat(emptyData);
      else {

        var removedEmpty = types.filter(item => {
        if(item.message == "" || item.message == null) {
            return false;
        }

        if(item.pickup == "" || item.pickup == null) {
            return false;
        }

        return true
      })

      return removedEmpty;

      }
    },
    getBulkTypeList(bulkTypes) {
        var outputArray = []
        bulkTypes.forEach(item => outputArray.push(item.name))
        return outputArray;
    },
    reset() {
      this.request = {
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        req_phone: null,
        req_email: null,
      };
    },
    resetSubmit() {
      this.submittedRequest = {
        req_assigned: null,
        req_type: null,
        req_location: null,
        req_zone: null,
        req_description: null,
        req_notes: null,
        req_contact: null,
        req_status: null,
        req_pickup: null,
        req_phone: null,
        req_email: null,
      };
    },
    requestCustomOpen() {
      this.collapseCustomState = "show";
      this.reset();
    },
    requestCustomClose() {
      this.collapseCustomState = "hide";
    },
    validationCheck() {
      if (!this.req_address_received || !this.request.req_location) {
        Toast.fire({
          type: "error",
          title: "Address Not Selected",
        });

        return false;
      }

      return true;
    },
    validateEmail(email) {
      const re = /^[^@\s]+@[^@\s\.]+\.[^@\.\s]+$/;
      return re.test(String(email).toLowerCase());
    },
    checkForRequestType(val) {
      if (Array.isArray(this.request.req_type)) {
        return this.request.req_type.includes(val);
      } else {
        return this.request.req_type == val;
      }
    },
    async addProduct() {
      if (!this.validationCheck()) {
        return;
      }
      var types = this.request.req_type;
      this.request_types = Array.from(types);
      this.submittedRequest = this.request;

      var date = new Date();
      var options = {
        weekday: "short",
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };
      options.timeZone = "America/New_York";
      this.request.timestamp = date.toLocaleDateString("en-US", options);
      this.request.req_status = "Submitted";
      if (Array.isArray(types)) {
        types.forEach((type) => {
          this.request.req_type = type;
          
          this.request.req_description = this.getDescriptionFromType(type);
          this.addRequest(this.request);
        });
      }

      /*Toast.fire({
        type: "success",
        title: "Bulk Trash Request Added",
      });*/
      $("#confirmationModal").modal("show");
      $("#product").modal("hide");
      this.reset();
    },
    addRequest(request) {
      if(this.user && this.user.isLoggedIn) {
            db.collection(dbSchema.users).doc(this.user.id).collection(dbSchema.requests).add(request)
      }
      else {
            db.collection(dbSchema.users).doc("_anonymous_").collection(dbSchema.requests).add(request)
      }
           
    },
    getDescriptionFromType(type) {
      return this.descriptions[type] || "";
    }
  },
};
</script>

<style scoped lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
